export enum GenerateLabelModal {
  GetShippingLabelModal = 'getShippingLabel',
  DropOffTypeSelectionModal = 'dropOffTypeSelection',
  ConfirmationModal = 'confirmation',
  AddressModal = 'address',
  ShippingContactModal = 'shippingContact',
  CourierPickUpDateSelectionModal = 'courierPickUpDateSelection',
  DigitalLabelTypeSelectionModal = 'digitalLabelTypeSelection',
  ReturnTheOrder = 'returnTheOrder',
  ReturnCurrencyConversionModal = 'returnCurrencyConversionModal',
  ShippingDiscountModal = 'shippingDiscountModal',
  DropOffPointMapModal = 'dropOffPointMapModal',
  OpenQrCodeModal = 'openQrCodeModal',
  TaxpayerRestrictionModal = 'taxpayerRestrictionModal',
  ActivateBalanceModal = 'activateBalanceModal',
  EstimatedRefundModal = 'estimatedRefundModal',
  CarrierChangeModal = 'carrierChangeModal',
  UnknownErrorModal = 'unknownErrorModal',
  DropOffPointTypeSelectionModal = 'dropOffPointTypeSelectionModal',
  GenericErrorModal = 'genericErrorModal',
  CancelOrderModal = 'cancelOrderModal',
  None = 'none',
}

export enum LabelType {
  LabelTypePdf = 1,
  LabelTypeCode = 2,
  LabelTypeQr = 3,
}

export enum DeliveryType {
  Home = 1,
  PickupPoint = 2,
  NoShipping = 3,
  Custom = 4,
}

export enum DistanceUnitEnum {
  Kilometers = 'km',
  Meters = 'm',
  Miles = 'mi',
  Feet = 'ft',
}

export enum DropOffPointType {
  Home = 1,
  Shop = 2,
}

export enum DropOffTypeKey {
  Mailbox = 'mailbox',
  PostOffice = 'postoffice',
  Home2Home = 'home2home',
  ReusablePackage = 'reusablepackage',
  MyOwnPackage = 'myownpackage',
  ContactlessDropoff = 'contactlessdropoff',
}

export enum DropOffsPointType {
  Point = 1,
  Home = 2,
}

export enum DeliveryOptionChangeRequestStatus {
  Accepted = 10,
  Cancelled = 20,
}
